import { render, staticRenderFns } from "./MallDueDaysSummary.vue?vue&type=template&id=d54bde76&scoped=true&"
import script from "./MallDueDaysSummary.vue?vue&type=script&lang=ts&"
export * from "./MallDueDaysSummary.vue?vue&type=script&lang=ts&"
import style0 from "./MallDueDaysSummary.vue?vue&type=style&index=0&id=d54bde76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54bde76",
  null
  
)

export default component.exports